var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top-wrap"},[_c('transition',{attrs:{"name":"slideup"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scY > 300),expression:"scY > 300"}],staticClass:"back-to-top pointer",on:{"click":_vm.toTop}},[_c('i',{staticClass:"fas fa-arrow-circle-up"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }